import localforage from "localforage";
import { makeObservable, observable, runInAction } from "mobx";
import BaseService from "../base/BaseService";

/**
 * MobX service used to contain shared service functionality.
 */
class LocalStorageService extends BaseService {
	@observable
	currentlyLoading = {};

	constructor(props) {
		super(props);
		makeObservable(this);
	}

	/**
	 * Loads session from browser storage. Used to persist data between refreshes.
	 * @returns {Promise<void>}
	 */
	load = async (namespace, sessionKey, callback) => {
		runInAction(() => {
			if (!this.currentlyLoading[namespace]) {
				this.currentlyLoading[namespace] = [];
			}

			this.currentlyLoading[namespace].push(sessionKey);
		});

		const sessionData = await localforage.getItem(sessionKey);

		runInAction(() => {
			let removeMe = this.currentlyLoading[namespace].indexOf(sessionKey);
			this.currentlyLoading[namespace].splice(removeMe, 1);
		});

		if (sessionData && callback) {
			callback(sessionData);
		}
	};

	/**
	 * Saves session to browser storage. Used to persist data between refreshes.
	 * @returns {Promise<void>}
	 */
	save = async (sessionKey, data) => {
		await localforage.setItem(sessionKey, data);
	};
}

export default LocalStorageService;
